/**
 * Display-only cleanup for status facet values that include a semicolon suffix
 * (e.g. "Recruiting Now;Active" → "Recruiting Now").
 */
export function formatStatusFacetLabel(value: string): string {
  const semicolonIndex = value.indexOf(';');
  if (semicolonIndex === -1) {
    return value;
  }
  return value.slice(0, semicolonIndex).trim();
}
